module.exports = __webpack_public_path__ + "img/cbd-freeze.d32f1892.jpg";